export const nameSuffixes = ['JR', 'III', 'IV', 'V'];
